<template>
  <div slot="operations">
    <div v-if="pageMode===1" style="display: inline-block; font-size: 14px; color: orangered;">
      <span style="padding-right: 15px; font-size: 14px;">{{ buildTitle() }}</span>
    </div>
    <el-button v-if="pageMode===1" type="primary" no="1" @click="$emit('toChangePage')">{{ $t('WriteOff.return') }}</el-button>
    <el-button v-if="pageMode===1" type="primary" no="2" @click="$emit('toHedgeWriteOff')">{{ $t('WriteOff.confirm') }}</el-button>
    <el-button v-if="pageMode!==1 && hasPermission()" type="primary" no="3" @click="$emit('toWriteOff')">{{ $t('WriteOff.writeOffs') }}</el-button>
    <el-button v-if="pageMode!==1 && hasPermission()" type="primary" no="4" @click="$emit('toChangePage')">{{ $t('WriteOff.hedgingWriteOffs') }}</el-button>
    <el-button v-if="pageMode!==1" type="primary" no="5" @click="$emit('toActualPayment')">{{ $t('WriteOff.actualReceiptAndPayment') }}</el-button>
    <el-dropdown v-if="pageMode!==1 && (role.ar || role.ap)" no="13" split-button type="primary" class="el-dropdown-spacing" @click="exportHandle()" @command="p=>{exportCommand=p;exportHandle()}">
      <span v-if="[$t('CargoMsg.Cargo_BatchImportAr2'), $t('CargoMsg.Cargo_BatchImportAp2')].includes(exportCommand)">{{ exportCommand }}</span>
      <el-upload
        v-if="[$t('CargoMsg.Cargo_BatchImportAr1'), $t('CargoMsg.Cargo_BatchImportAp1')].includes(exportCommand)"
        :action="URL.act.actualAmount.batchImportWriteOffUrl"
        :headers="headers"
        :show-file-list="false"
        accept=".xls, .xlsx"
        :before-upload="beforeOrderUpload"
        :on-success="uploadOrderSuccess"
        :on-error="handleError"
        :data="{branchId:$store.getters.currentOfficeId, type:1}"
        style="display: inline-block; margin-left: 5px"
      >
        <span style="color: white">{{ exportCommand }}</span>
      </el-upload>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item v-if="[-1, 1].includes(searchConditions.isAr) && role.ar" :command="$t('CargoMsg.Cargo_BatchImportAr1')">
          <el-upload
            ref="batchImportAr"
            :action="URL.act.actualAmount.batchImportWriteOffUrl"
            :headers="headers"
            :show-file-list="false"
            accept=".xls, .xlsx"
            :before-upload="beforeOrderUpload"
            :on-success="uploadOrderSuccess"
            :on-error="handleError"
            :data="{branchId:$store.getters.currentOfficeId, type:1}"
            style="display: inline-block;"
          >
            <span>{{ $t('CargoMsg.Cargo_BatchImportAr1') }}</span>
          </el-upload>
        </el-dropdown-item>
        <el-dropdown-item v-if="[-1, 0].includes(searchConditions.isAr) && role.ap" :command="$t('CargoMsg.Cargo_BatchImportAp1')">
          <el-upload
            ref="batchImportAp"
            :action="URL.act.actualAmount.batchImportWriteOffUrl"
            :headers="headers"
            :show-file-list="false"
            accept=".xls, .xlsx"
            :before-upload="beforeOrderUpload"
            :on-success="uploadOrderSuccess"
            :on-error="handleError"
            :data="{branchId:$store.getters.currentOfficeId, type:0}"
            style="display: inline-block;"
          >
            <span>{{ $t('CargoMsg.Cargo_BatchImportAp1') }}</span>
          </el-upload>
        </el-dropdown-item>
        <el-dropdown-item v-if="[-1, 1].includes(searchConditions.isAr) && role.ar" :command="$t('CargoMsg.Cargo_BatchImportAr2')">{{ $t('CargoMsg.Cargo_BatchImportAr2') }}</el-dropdown-item>
        <el-dropdown-item v-if="[-1, 0].includes(searchConditions.isAr) && role.ap" :command="$t('CargoMsg.Cargo_BatchImportAp2')">{{ $t('CargoMsg.Cargo_BatchImportAp2') }}</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <el-button v-if="searchConditions.writeOffMode===2" type="primary" style=" margin-left: 5px" @click="autoReceivablesWriteOff">{{ $t('CargoMsg.Cargo_AutoReceivablesWriteOff') }}</el-button>
    <file-upload-success-dialog
      v-if="fileUploadSuccessDialog.visible"
      ref="fileUploadSuccessDialog"
      :visible.sync="fileUploadSuccessDialog.visible"
      :code="fileUploadSuccessDialog.code"
      @cancelCallback="fileUploadSuccessDialog.visible = false"
    />

    <!-- 验证规则弹窗 -->
    <checking-save-job-window
      v-if="checkingSaveJobWindow.visible"
      :visible.sync="checkingSaveJobWindow.visible"
      :lob="checkingSaveJobWindow.lob"
      :row-data="checkingSaveJobWindow.rowData"
      :check-node="checkingSaveJobWindow.checkNode"
      :call-back="checkingSaveJobWindow.callBack"
    />

  </div>
</template>
<script>

import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import URL from '@/api/urlTranslator'
import FileUploadSuccessDialog from '@/views/cargo/v0/Clearing/components/Writeoff/fileUploadSuccessDialog.vue'
import {
  BATCH_IMPORT_OF_PAYMENT_WRITE_OFF,
  BATCH_IMPORT_OF_RECEIPT_WRITE_OFF
} from '@/class/cargo/model/parameters/DocumentConstants'
import { cache, cacheName } from '@/utils/cacheManager'
import { checkAnyContent } from '@/api/sysManage/baseConfig/checkRuleConfig'
import * as CheckRuleConstants from '@/class/cargo/model/parameters/CheckRuleConstants'
import checkingSaveJobWindow from '@/components/Cargo/Job/CheckingManager/CheckingSaveJobWindow.vue'
import { autoChargeWriteOffFunc, batchWriteOffFunc } from '@/api/clearing/actualAmount'

export default {
  name: 'WriteoffOperations',
  components: { checkingSaveJobWindow, FileUploadSuccessDialog },
  props: {
    pageMode: { type: Number, default: 0 }, // 页面模式: 0-未销账列表 1-销账列表
    searchConditions: { type: Object, required: true }
  },
  data() {
    return {
      URL,
      role: {
        ar: this.$checkPermission(['role_ACWriteoff_BatchImportAr']),
        ap: this.$checkPermission(['role_ACWriteoff_BatchImportAp'])
      },
      fileUploadSuccessDialog: {
        visible: false,
        code: 0
      },
      headers: {
        sessionId: this.$store.getters.token,
        ContentType: 'multipart/form-data'
      },
      checkingSaveJobWindow: {
        lob: '',
        visible: false,
        checkNode: 0,
        callBack: null,
        rowData: []
      },
      exportCommand: this.$t('CargoMsg.Cargo_BatchImportAr1'),
      loading: false
    }
  },
  created() {
    if (this.role.ar) {
      this.exportCommand = this.$t('CargoMsg.Cargo_BatchImportAr1')
    } else if (this.role.ap) {
      this.exportCommand = this.$t('CargoMsg.Cargo_BatchImportAp1')
    } else {
      this.exportCommand = ''
    }
  },
  methods: {
    // 构建对冲销账页面提示语(切换到对冲销账页面模式才使用,根据原始销账页面选择的销账模式拼接)
    buildTitle() {
      let labelAr = this.$t('CargoMsg.Cargo_Receivable')
      if (this.searchConditions.isAr === -1) {
        labelAr = this.$t('CargoMsg.Cargo_All')
      } else {
        labelAr = this.searchConditions.isAr ? this.$t('CargoMsg.Cargo_Receivable') : this.$t('CargoMsg.Cargo_Dues')
      }
      let tip = this.$t('WriteOff.selectHedgingTheInvoice') + labelAr
      // todo: fixme: 应设置单独变量存放销账模式页面下的变量值(在获取数据后更新)，并用于此处
      switch (this.searchConditions.writeOffMode) {
        case 1: tip += this.$t('CargoMsg.Cargo_Cost')
          break
        case 2: tip += this.$t('CargoMsg.Cargo_Invoice')
          break
        case 3: tip += this.$t('CargoMsg.Cargo_Bill')
          break
        case 4: tip += this.$t('CargoMsg.Cargo_AccountStatement')
          break
        case 5: tip += this.$t('CargoMsg.Cargo_PaymentRequest')
          break
      }
      return tip
    },
    hasPermission() {
      if (this.$checkPermission(['button_ACWriteoff_writeoff'])) {
        return true
      }
      return false
    },
    // 导出公共
    exportHandle() {
      switch (this.exportCommand) {
        case this.$t('CargoMsg.Cargo_BatchImportAr1'):
          this.$refs.batchImportAr.submit()
          break
        case this.$t('CargoMsg.Cargo_BatchImportAp1'):
          this.$refs.batchImportAp.submit()
          break
        case this.$t('CargoMsg.Cargo_BatchImportAr2'):
          ExportUtils.downloadTemplateFile('BatchImportArWriteOff.xlsx', 'actualAmount')
          break
        case this.$t('CargoMsg.Cargo_BatchImportAp2'):
          ExportUtils.downloadTemplateFile('BatchImportApWriteOff.xlsx', 'actualAmount')
          break
      }
    },
    handleError(error) {
      const errorData = JSON.parse(error.message)
      this.$message.error({ 'message': errorData.message, 'duration': 15000 })
      this.loading.close()
    },
    beforeOrderUpload(file) {
      this.loading = getLoading()
      const fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = fileType === 'xls'
      const extension2 = fileType === 'xlsx'
      if (!extension && !extension2) {
        this.loading.close()
        this.$message.warning(this.$t('SeaExport.FileOnlyXlsXlsx'))
      }
      return extension || extension2
    },
    // 上传成功
    uploadOrderSuccess(res, file, fileList) {
      this.loading.close()
      if (res.ok) {
        if (res.data && res.data.data && res.data.data.length > 0) {
          this.doCheck(res.data)
        } else {
          this.$message.warning(this.$t('CargoMsg.Cargo_NoData'))
        }
      } else {
        this.$confirm(res.message, this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          canCloseModule: true,
          type: 'warning'
        })
      }
    },
    async doCheck(res) {
      await cache.load(cacheName.CONFIG)
      if (Number(cache.config.get('useCheckRule')) === 1) {
        let checkResult = null
        let needShowDialog = false
        this.loading = getLoading4Cxt(this)
        await checkAnyContent(res, CheckRuleConstants.NODE_IMPORT_CHARGE_WRITE_OFF.code).then(res => {
          checkResult = res.data
          for (const checkRule of checkResult) {
            if (checkRule && checkRule.expressions) {
              for (const item of checkRule.expressions) {
                if (!item.match) {
                  needShowDialog = true
                  break
                }
              }
            }
            if (needShowDialog) {
              break
            }
          }
        }).finally(() => this.loading.close())
        if (needShowDialog) {
          const callBack = () => { this.doImport(res) }
          this.checkingSaveJobWindow.checkNode = CheckRuleConstants.NODE_IMPORT_CHARGE_WRITE_OFF.code
          this.checkingSaveJobWindow.rowData = checkResult
          this.checkingSaveJobWindow.callBack = callBack
          this.checkingSaveJobWindow.visible = true
        } else {
          await this.doImport(res)
        }
      } else {
        await this.doImport(res)
      }
    },
    doImport(res) {
      // 导入数据 res
      batchWriteOffFunc(res).then(res => {
        switch (this.exportCommand) {
          case this.$t('CargoMsg.Cargo_BatchImportAr1'):
            this.fileUploadSuccessDialog.code = BATCH_IMPORT_OF_RECEIPT_WRITE_OFF.code
            break
          case this.$t('CargoMsg.Cargo_BatchImportAp1'):
            this.fileUploadSuccessDialog.code = BATCH_IMPORT_OF_PAYMENT_WRITE_OFF.code
            break
        }
        this.fileUploadSuccessDialog.visible = true
      }).catch(err => {
        this.$message.error({ 'message': err.message, 'duration': 15000 })
      })
    },
    // 自动核销发票和实收实付记录
    async autoReceivablesWriteOff() {
      this.loading = getLoading()
      await autoChargeWriteOffFunc({ branchId: this.$store.getters.currentOfficeId }).then(res => {
        if (res) {
          this.$message.success(this.$t('CargoMsg.Cargo_RecordsWrittenOff', [res.data]))
        }
      }).finally(res => {
        this.loading.close()
      })
    }
  }
}
</script>
